import React from "react"
import Block from "@/components/Block"
import styled from "@emotion/styled"
import css from "@styled-system/css"
import Box from "@/components/Box"
import Flex from "@/components/Flex"
import Typography from "@/components/Typography"
import { useTranslation } from "react-i18next"
import { m } from "framer-motion"
//import { mobileFirstDevice } from "@/utils/media-queries"

const duration = 0.8
const delay = 0.3
const transitionParams = { duration: duration, bounce: 0, ease: "linear" }

const GradientText = styled(Typography)`
  background: linear-gradient(90deg, #1199fa 0%, #0b1426 100%);
  -webkit-text-fill-color: transparent;
  -webkit-background-clip: text;
`

const DarkCover = styled(m.div)`
  position: absolute;
  width: 95%;
  height: 89%;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 47px 47px 0px 0px;
  left: 8px;
`
const CheckoutCart = styled(m.img)`
  position: absolute;
  width: 94%;
  left: 9px;
`

const PaymentMethod = styled(m.img)`
  position: absolute;
  width: 94%;
  top: 58px;
`
const SendPayment = styled(m.img)`
  position: absolute;
  width: 94%;
  left: 9px;
  border-radius: 0px 0px 47px 47px;
`

const Container = styled(Box)`
  ${css({
    maxWidth: "containerWidth",
    mx: "auto",
    my: 0,
    px: ["20px", 7, 3],
  })}
`

export const CheckoutSection = ({
  SendPayMentUI,
}: {
  SendPayMentUI: string
}) => {
  const { t } = useTranslation("payCustomer")
  return (
    <Block bg={"#FFF"}>
      <Container>
        <GradientText
          textAlign={"center"}
          as="h1"
          variant="h1"
          maxWidth={["unset", 470, 750]}
          mx={"auto"}
          mb={[248, 248, 232]}
        >
          {t("newFeature.title")}
        </GradientText>
        <Flex
          flexDirection={["column", "row", "row"]}
          customCss={{ gap: [5, 4, 11] }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Box position={"relative"} width={[329]} overflow={"hidden"}>
            <DarkCover
              viewport={{ once: true }}
              transition={{ ...transitionParams, delay: delay }}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
            ></DarkCover>
            <Box
              as="img"
              src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/checkout/phone-frame.webp`}
              width={"100%"}
              loading="lazy"
              alt="Mobile phone screen displaying Aston Martin F1 teamwear available for purchase with Crypto.com Pay."
            />
            <CheckoutCart
              initial={{ top: "calc(0% - 182px)", opacity: 0 }}
              whileInView={{ top: "9.5%", opacity: 1 }}
              viewport={{ once: true }}
              transition={{ ...transitionParams, delay: delay }}
              src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/checkout/checkout-cart.webp`}
              alt="Mobile phone screen showcasing the process of adding Aston Martin F1 teamwear to the shopping cart on an online outlet."
            />
            <PaymentMethod
              initial={{ left: "100%", opacity: 0 }}
              whileInView={{ left: "9px", opacity: 1 }}
              viewport={{ once: true }}
              transition={{ ...transitionParams, delay: duration + 2 * delay }}
              src={`${process.env.ASSETS_BASE_URL}/pay/customer-page/checkout/select-payment.webp`}
              alt="Mobile phone screen demonstrating the online purchase process with the selection of Crypto.com Pay as the payment method."
            />
            <SendPayment
              initial={{ bottom: -521, opacity: 0 }}
              whileInView={{ bottom: 12, opacity: 1 }}
              viewport={{ once: true }}
              transition={{
                ...transitionParams,
                delay: 2 * duration + 3 * delay,
              }}
              src={SendPayMentUI}
              alt="Mobile phone screen displaying available tokens for Pay Checkout: CRO, BTC, ETH, USDT, XRP, and USDC. Option to send payment now."
            />
          </Box>
          <Typography
            color="#0B1426"
            variant="h2"
            as="h2"
            maxWidth={[247, null, 380]}
            mr={["auto", 0, 0]}
          >
            {t("newFeature.description")}
          </Typography>
        </Flex>
      </Container>
    </Block>
  )
}
